import { IconProps } from "./Icon.model";

export function CheckmarkCircle02({
  size = 16,
  fill = "currentColor",
}: IconProps) {
  const fillColor =
    fill === "currentColor"
      ? "currentColor"
      : fill === "green"
      ? "var(--green-9)"
      : `var(--${fill}-a8)`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 0.833008C11.958 0.833008 15.167 4.04196 15.167 8C15.167 11.958 11.958 15.167 8 15.167C4.04196 15.167 0.833008 11.958 0.833008 8C0.833008 4.04196 4.04196 0.833008 8 0.833008ZM11.1172 5.50879C10.8458 5.25999 10.4236 5.27839 10.1748 5.5498L6.97949 9.03613L5.80469 7.8623C5.54434 7.60196 5.12265 7.60196 4.8623 7.8623C4.60196 8.12265 4.60196 8.54434 4.8623 8.80469L6.52832 10.4717C6.6569 10.6003 6.83286 10.6709 7.01465 10.667C7.19638 10.663 7.36838 10.5842 7.49121 10.4502L11.1582 6.4502C11.4068 6.17882 11.3884 5.75754 11.1172 5.50879Z"
        fill={fillColor}
      />
    </svg>
  );
}

